import Bloc from './Bloc.js';
import Types from './Types.js';

export default class AddProperty extends Bloc {

	constructor (src, ctx) {

		super("addproperty", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].addProperty(ins[1]);
			return [];
		};
		this.types = [Types.card, Types.property];
	}
}